import { ServerApiClient } from '../ServerApiClient';
import { isFuseGridDesktop } from './isDesktop';

function extractCodeFromUrl(raw: string): string {
  const s = String(raw || '').trim()
  if (!s) return ''
  try {
    const u = new URL(s)
    const code = String(u.searchParams.get('code') || '').trim()
    return code
  } catch {
    // Not a valid URL string
    return ''
  }
}

async function handleDeepLinkUrl(rawUrl: string) {
  const code = extractCodeFromUrl(rawUrl)
  if (!code) return

  const api = new ServerApiClient()
  const device = {
    platform: navigator.platform || null,
    userAgent: navigator.userAgent || null,
    ts: Date.now(),
  }
  const out = await api.desktopRedeemOpenIntent({ code, device })

  // Persist workbook selection + optional state payload.
  try {
    if (out?.workbook_id) window.localStorage.setItem('fusegrid_workbook_id', String(out.workbook_id))
    if (out?.state != null) window.localStorage.setItem('fusegrid_desktop_open_state', JSON.stringify(out.state))
  } catch {
    // ignore
  }

  // Navigate by setting query param (this matches how `App.tsx` reads workbook_id).
  const sp = new URLSearchParams(window.location.search)
  if (out?.workbook_id) sp.set('workbook_id', String(out.workbook_id))
  const next = `${window.location.pathname}?${sp.toString()}`
  if (window.location.href !== next) window.location.href = next
}

export async function installDesktopDeepLinking(): Promise<void> {
  if (!isFuseGridDesktop()) return

  // Avoid bundling the plugin into the web build eagerly.
  const mod = await import('@tauri-apps/plugin-deep-link')
  const onOpenUrl: (handler: (urls: string[]) => void) => Promise<() => void> = (mod as any).onOpenUrl
  const getCurrent: () => Promise<string[]> = (mod as any).getCurrent

  try {
    const urls = await getCurrent()
    for (const u of (urls || [])) {
      try { await handleDeepLinkUrl(u) } catch (e) { console.warn('[desktop] deep link handle failed', e) }
    }
  } catch {
    // ignore
  }

  try {
    await onOpenUrl((urls: string[]) => {
      for (const u of (urls || [])) {
        void handleDeepLinkUrl(u).catch((e) => console.warn('[desktop] deep link handle failed', e))
      }
    })
  } catch (e) {
    console.warn('[desktop] deep link subscription failed', e)
  }
}

